import {FALLBACK_LANGUAGE} from '@online-offer/i18n';
import {AppLanguage} from 'platform/locale';

import {Nullish} from 'shared/web';

import {WarrantyTermsAndConditionsResponseBody} from '../../../api/types/onlineOfferTypes';

// API locales include regions, while AppLanguage uses base language codes.
export function getWarrantyTermsForLanguage(
  terms: WarrantyTermsAndConditionsResponseBody[] | Nullish,
  language: AppLanguage
) {
  const findByLanguage = (target: AppLanguage) =>
    terms?.find(
      (entry) => entry.text.trim().length > 0 && entry.locale.toLowerCase().split('-')[0] === target
    )?.text;

  return findByLanguage(language) ?? findByLanguage(FALLBACK_LANGUAGE) ?? null;
}
